export type TLosslessFormat = 'wav' | 'flac' | 'aiff'

const MIME_TO_FORMAT: Record<string, TLosslessFormat> = {
    'audio/wav': 'wav',
    'audio/vnd.wave': 'wav',
    'audio/wave': 'wav',
    'audio/x-wav': 'wav',
    'audio/flac': 'flac',
    'audio/x-flac': 'flac',
    'audio/aiff': 'aiff',
    'audio/x-aiff': 'aiff',
}

const EXTENSION_TO_FORMAT: Record<string, TLosslessFormat> = {
    wav: 'wav',
    flac: 'flac',
    aif: 'aiff',
    aiff: 'aiff',
}

export const getLosslessFormat = ({
    type,
    name,
}: {
    type?: string
    name?: string
}): TLosslessFormat | null => {
    const fromMime = type ? MIME_TO_FORMAT[type.toLowerCase()] : undefined

    if (fromMime) {
        return fromMime
    }

    const extension = name?.split('.').pop()?.toLowerCase()

    return extension ? (EXTENSION_TO_FORMAT[extension] ?? null) : null
}

export const getBatchLosslessFormat = (
    files: Iterable<{ type?: string; name?: string }>,
): TLosslessFormat | null => {
    for (const file of files) {
        const format = getLosslessFormat(file)

        if (format) {
            return format
        }
    }

    return null
}
